const STATUS_COLORS: Record<string, string> = {
  draft: '#6b7280',
  submitted: '#3b82f6',
  accepted: '#22c55e',
  rejected: '#ef4444',
  withdrawn: '#f59e0b',
};

export function OfferStatusBadge({ status }: { status: string }) {
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: '999px',
      fontSize: '0.7rem',
      fontWeight: 600,
      color: 'white',
      background: STATUS_COLORS[status] || '#6b7280',
      textTransform: 'capitalize',
    }}>
      {status}
    </span>
  );
}
